import { ROUTES } from '@/shared/config/routes';

/**
 * Link columns, declared as data.
 *
 * The generated markup repeated the same list-item block nine times; listing
 * the columns instead means a new footer link is one line.
 */
export const FOOTER_COLUMNS = [
  {
    titleKey: 'footer.product',
    links: [
      { to: ROUTES.features, labelKey: 'footer.features' },
      { to: ROUTES.pricing, labelKey: 'footer.pricing' },
      { to: ROUTES.reviews, labelKey: 'footer.reviews' },
      { to: ROUTES.updates, labelKey: 'footer.updates' },
    ],
  },
  {
    titleKey: 'footer.company',
    links: [
      { to: ROUTES.about, labelKey: 'footer.about' },
      { to: ROUTES.blog, labelKey: 'footer.blog' },
      { to: ROUTES.contact, labelKey: 'footer.contact' },
      { to: ROUTES.privacy, labelKey: 'footer.privacy' },
      { to: ROUTES.terms, labelKey: 'footer.terms' },
    ],
  },
  {
    // Crawlable links to the comparison pages from every public page.
    titleKey: 'footer.compare',
    links: (Object.keys(ROUTES.vs) as (keyof typeof ROUTES.vs)[]).map((id) => ({
      to: ROUTES.vs[id],
      labelKey: `footer.vs.${id}`,
    })),
  },
] as const;
